import { fork, all } from 'redux-saga/effects';
import redpacketSaga from './redpacket';
import celebration2018Saga from './celebration2018';

export default function* gameSaga() {
  yield all([fork(redpacketSaga), fork(celebration2018Saga)]);
}
